import { CSSProperties } from "react"
import Skeleton from 'react-loading-skeleton'

export function mapLoading(condition : boolean, array : JSX.Element[] | undefined, loadingCount : number = 1, loadingCss? : CSSProperties | undefined): JSX.Element | JSX.Element[]{
   if(condition == true && array != undefined){
    return array
   }else{
    return <Skeleton style={loadingCss} count={loadingCount} />
   }
}


export function none(){}

// export function handler<J>(eventHandler: (e:J)=>void) {
//  return (e: J) => {
//    // lógica para o evento (pode ser o preventDefault ou qualquer outra lógica genérica)
//    eventHandler(e);
//  }
// }